var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9371 9.50262V8.61373C7.9371 8.14223 7.7498 7.69004 7.4164 7.35664C7.083 7.02324 6.63081 6.83594 6.15931 6.83594H3.49263C3.02113 6.83594 2.56895 7.02324 2.23555 7.35664C1.90215 7.69004 1.71484 8.14223 1.71484 8.61373V9.50262",
    stroke: "#2173FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82662 5.05558C5.80846 5.05558 6.6044 4.25963 6.6044 3.27779C6.6044 2.29594 5.80846 1.5 4.82662 1.5C3.84477 1.5 3.04883 2.29594 3.04883 3.27779C3.04883 4.25963 3.84477 5.05558 4.82662 5.05558Z",
    stroke: "#2173FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6042 9.49695V8.60806C10.6039 8.21416 10.4728 7.83151 10.2315 7.52019C9.99012 7.20888 9.65223 6.98653 9.27084 6.88805M7.9375 1.55469C8.31991 1.6526 8.65885 1.875 8.9009 2.18683C9.14295 2.49866 9.27433 2.88217 9.27433 3.27692C9.27433 3.67166 9.14295 4.05518 8.9009 4.36701C8.65885 4.67884 8.31991 4.90124 7.9375 4.99915",
    stroke: "#2173FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentShare);
export default __webpack_public_path__ + "static/media/agent-share.1820ba51e72a17e41057777f805c3e71.svg";
export { ForwardRef as ReactComponent };